import type { Locale } from './locales';

/** Фиксированный список категорий MVP (DATABASE.md §3.4). Пользовательские — V2. */
export const CATEGORY_CODES = ['food', 'coffee', 'taxi', 'shopping', 'cash', 'other'] as const;
export type TransactionCategory = (typeof CATEGORY_CODES)[number];

export const CATEGORIES: Record<
  TransactionCategory,
  { emoji: string; label: Record<Locale, string> }
> = {
  food: { emoji: '🍽', label: { ru: 'Еда', uz: 'Овқат' } },
  coffee: { emoji: '☕', label: { ru: 'Кофе', uz: 'Қаҳва' } },
  taxi: { emoji: '🚕', label: { ru: 'Такси', uz: 'Такси' } },
  shopping: { emoji: '🛒', label: { ru: 'Покупки', uz: 'Харидлар' } },
  cash: { emoji: '💵', label: { ru: 'Наличные', uz: 'Нақд пул' } },
  other: { emoji: '📝', label: { ru: 'Другое', uz: 'Бошқа' } },
};

export function categoryLabel(code: string | null | undefined, locale: Locale): string | null {
  if (!code || !(code in CATEGORIES)) return null;
  return CATEGORIES[code as TransactionCategory].label[locale];
}

export const SETTLEMENT_EMOJI = '💸';
